import { componentQrl, inlinedQrl, _jsxQ, _fnSignal } from "@builder.io/qwik";
const InlinedStyles = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ _jsxQ("style", null, {
    dangerouslySetInnerHTML: _fnSignal((p0) => p0.styles, [
      props
    ], "p0.styles"),
    "data-id": _fnSignal((p0) => p0.id, [
      props
    ], "p0.id"),
    nonce: _fnSignal((p0) => p0.nonce, [
      props
    ], "p0.nonce")
  }, null, 3, "NG_0");
}, "InlinedStyles_component_IOsg46hMexk"));
export {
  InlinedStyles,
  InlinedStyles as default
};
